var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 5.83325C6.33301 6.15542 6.59418 6.41659 6.91634 6.41659V9.91659C6.59418 9.91659 6.33301 10.1778 6.33301 10.4999C6.33301 10.8221 6.59418 11.0833 6.91634 11.0833H8.08301C8.40517 11.0833 8.66634 10.8221 8.66634 10.4999C8.66634 10.1778 8.40517 9.91659 8.08301 9.91659V5.24992H6.91634C6.59418 5.24992 6.33301 5.51109 6.33301 5.83325Z",
    fill: "#5051F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49967 4.66659C7.98292 4.66659 8.37467 4.27483 8.37467 3.79159C8.37467 3.30834 7.98292 2.91659 7.49967 2.91659C7.01643 2.91659 6.62467 3.30834 6.62467 3.79159C6.62467 4.27483 7.01643 4.66659 7.49967 4.66659Z",
    fill: "#5051F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9163 2.33325C13.9163 1.36675 13.1328 0.583252 12.1663 0.583252H2.83301C1.86651 0.583252 1.08301 1.36675 1.08301 2.33325V11.6666C1.08301 12.6331 1.86651 13.4166 2.83301 13.4166H12.1663C13.1328 13.4166 13.9163 12.6331 13.9163 11.6666V2.33325ZM12.7497 2.33325C12.7497 2.01109 12.4885 1.74992 12.1663 1.74992H2.83301C2.51084 1.74992 2.24967 2.01109 2.24967 2.33325V11.6666C2.24967 11.9888 2.51084 12.2499 2.83301 12.2499H12.1663C12.4885 12.2499 12.7497 11.9888 12.7497 11.6666V2.33325Z",
    fill: "#5051F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.099bac5494c3991157f11de74c6b4942.svg";
export { ForwardRef as ReactComponent };